import { styled } from "@styles";
import { Card } from "react-bootstrap";


export const Wrapper = styled.div``;

export const OrderPaymentDetailCard = styled(Card)`
  margin-bottom: 1rem;
`;

export const OrderPaymentDetailHeader = styled(Card.Header)``;

export const OrderPaymentDetailBody = styled(Card.Body)``;

export const OrderPaymentDetailP = styled.p`
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  margin: 0;
`;

export const Td = styled.td`
`;

export const Discount = styled.td`
  color: #FF3398;
`;

export const TableItemRight = styled.td`
  text-align: right;
`;

export const TableItemRightPoint = styled.td`
  text-align: right;
  color: #2983FF;
`;

export const TableItemRightDiscount = styled.td`
  text-align: right;
  color: #FF3398;
`;

export const Hr = styled.hr`
  border-top: 1px solid black;
`;

export const TextMuted = styled.label`
  font-size: x-small;
  color: #6c757d !important;
`;